import React from 'react';

/**
 * ErroreLettura — il messaggio di una prima lettura non riuscita, con
 * «Riprova» che la rifa' (Claude, 3/11/2026; utils/primaLettura.js).
 *
 * PERCHE'. Con i rilasci di giorno il backend si riavvia a clinica aperta, e
 * per un secondo e mezzo Nginx risponde 502: la pagina riprova da sola una
 * volta (conUnTentativo), e se non basta lo dice col motivo
 * (motivoDellaLettura) e lascia «Riprova», invece di restare ferma su un
 * testo generico finche' qualcuno non ricarica.
 *
 * Solo per le LETTURE: l'errore di un salvataggio non si riprova da qui (una
 * scrittura ripetuta puo' scrivere due volte), e chi usa questo componente
 * tiene l'errore della lettura in uno stato suo, che la lettura riuscita
 * toglie, separato da quello dei salvataggi.
 *
 * `classe` e' il riquadro d'errore della pagina, cosi' il messaggio ha lo
 * stile di sempre; il pulsante prende il colore del riquadro (.rm-riprova,
 * tema.css).
 */
const ErroreLettura = ({ testo, onRiprova, classe = 'rm-messaggio rm-messaggio-errore', Contenitore = 'p', role }) => {
    if (!testo) return null;
    return (
        <Contenitore className={classe} data-errore-lettura="" role={role}>
            {testo}
            {' '}
            <button type="button" className="rm-riprova" onClick={onRiprova}>Riprova</button>
        </Contenitore>
    );
};

export default ErroreLettura;
